import React, { useEffect, useState, useContext } from 'react'
import './index.sass';

import { AuthInput } from '../../components/common/Input'
import { ButtonRed, ButtonPink, ButtonGoogle, ThemeSwitcher } from '../../components/common/Button'
import { useHistory } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { loginUser } from '../../api/auth'
import { ErrorValidator } from '../../components/common/Validator';
import { DarkModeContext } from '../../global/Theme'

import PWA from '../../utils/PWA'

export default function Login() {
    const { isDark } = useContext(DarkModeContext);
    const [email, setEmail] = useState("")
    const [password, setPassword] = useState("")
    const [loggingIn, setLoggingIn] = useState(false);
    const dispatch = useDispatch();
    const history = useHistory();
    const [errorCode, setErrorCode] = useState("");
    const [error, setError] = useState("");
    const [emailError, setEmailError] = useState(false);
    const [passwordError, setPasswordError] = useState(false);
    const [rememberMe, setRememberMe] = useState(true);

    useEffect(() => {
        // console.log(errorCode)
        // console.log(errorCode.split("/")[1])
        setError(errorCode.split("/")[1])
        
        if (errorCode.split("/")[1] == 'user-not-found') {
            setEmailError(true);
        } else if (errorCode.split("/")[1] == 'wrong-password') {
            // console.log(errorCode, "else")

            setPasswordError(true);
        }
    }, [errorCode])

    

    useEffect(() => {
        document.getElementById('desktopWrapper').style.display = 'none';
        document.getElementById('mobileWrapper').style.display = 'none';
    })

    const handleOnClickLogin = async (e) => {
        setErrorCode('')
        setEmailError(false);
        setPasswordError(false);
        e.preventDefault();
        try {
            setLoggingIn(true)
            const res = await loginUser(email, password, setErrorCode, rememberMe);
            // console.log('response is', res)
            dispatch({
                type: 'TOOGLE_LOGGEDIN'
            })
            dispatch({
                type: 'UPDATE_USER_DATA',
                payload: res,
            })
            dispatch({
                type: 'UPDATE_NAV', payload: {
                    notification: false,
                    home: true,
                    search: false,
                    post: false,
                    chat: false,
                    profile: false
                }
            })
            document.getElementById('desktopWrapper').style.display = 'flex';
            document.getElementById('mobileWrapper').style.display = 'flex';
            document.getElementById('desktopNav').style.display = 'flex';
            history.push('/home')

        } catch (e) {
            setLoggingIn(false)
        }

    }

    const handleOnClickSignup = (e) => {
        e.preventDefault();
        history.push('/register')

    }

    const handleForgotPassword = () => {
        history.push('/reset-password')
    }

    const toggleRememberMe = () => {
        setRememberMe(!rememberMe)
    }

    const handleEnterKey = (event) => {
        if(event.key === 'Enter'){
            // console.log('behenchod')
            handleOnClickLogin(event);
        }
    }

    return (
        <div className='lover-authCard-wrapper' onKeyDown={handleEnterKey} >
            <ThemeSwitcher />
            <div className='lover-authCard-wrapper-header'>
                {isDark ? <img className='lover-logo lover-logo-size' src={require('../../assets/icons/logoanim-dark.gif')} /> : <img className='lover-logo lover-logo-size' src={require('../../assets/icons/logoanim-light.gif')} />}
                
            </div>
            <div className='login-install-row'>
                <PWA />
            </div>
            <div className='lover-authCard-wrapper-body'>
                <AuthInput handleInputChange={e => setEmail(e.target.value)} type='email' placeholder='Email or Username' icon='user.svg' isError={emailError} />
                {emailError && <ErrorValidator text="Email/Username not found!" />}
                <AuthInput handleInputChange={e => setPassword(e.target.value)} type='password' placeholder='Password' icon='lock.svg' isError={passwordError} />
                {passwordError && <ErrorValidator text="Incorrect Password" />}

                {/* {(error == "wrong-password") ? <ErrorValidator text="Wrong Password" /> : (error == "user-not-found") ? <ErrorValidator text="Incorrect Email" /> : ""} */}
                <div className='lover-forgot-remember-row'>
                <div onClick={toggleRememberMe}>
                    <img src={rememberMe ? require('../../assets/icons/checkbox_a.svg') : require('../../assets/icons/checkbox.svg')}/>
                    <p>Remember me</p>
                </div>
                <p onClick={handleForgotPassword} style={{ cursor: 'pointer' }}>Forgot Password?</p>
                </div>
                <ButtonRed text={loggingIn ? 'Please Wait' : "LOGIN"} icon="login.svg" handleOnClick={handleOnClickLogin} />
                <ButtonPink text="CREATE ACCOUNT" navigateTo='/register' handleOnClick={handleOnClickSignup} />
                <p className='lover-secondary-text'>OR</p>
                <ButtonGoogle />
                <div className="bottom-menu">
                    <p><a href="/about">ABOUT</a> • <a href="/help">HELP</a> • <a href="/terms">TERMS</a> • <a href="/privacy">PRIVACY</a> • <a href="/cookies">COOKIES</a> • <a href="/copyright">COPYRIGHT</a></p>
                    <h5>© 2021 Copyright by LOVR.online . All Rights reserved!</h5>
                </div>
            </div>
        </div>
    )
}
